var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": "输入名称或编号查询..."
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v("\n                搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e()], 1), _vm._v(" "), (_vm.caigoumobans.length) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.columns1,
      "loading": _vm.loading,
      "data": _vm.caigoumobans
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": ""
    },
    on: {
      "on-change": _vm.pageChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.caigoumobans.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("选择要使用的模板")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-042d2202","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CaigoumobanSelector.vue
// module id = WGLs
// module chunks = 142